import * as filters from '../utils/filters';
import { storeScope } from './storeScope';
import Grams from '../components/GramsLabel.vue';
import Kg from '../components/KgLabel.vue';
import Liquid from '../components/LiquidLabel.vue';
import Srm from '../components/SrmLabel.vue';
import Temp from '../components/TempLabel.vue';
import Percent from '../components/PercentChange.vue';

export default function register(app) {
  app.mixin(storeScope);
  app.mixin({ methods: filters });
  for (const [name, component] of Object.entries({ 'grams-label': Grams, 'kg-label': Kg, 'liquid-label': Liquid, 'srm-label': Srm, 'temp-label': Temp, 'percent-change': Percent })) app.component(name, component);
}
